// Auto-generated for /pages/categories during Magento → Shopify migration.
// Loaded with <script defer> so DOM is ready before this runs.

(function() {
    'use strict';

    var FEATURED = [
        {
            category: 'solder-paste',
            tag: 'Soldering',
            title: 'Solder Paste',
            description: 'Lead-free and leaded formulations for SMT assembly',
            url: '/soldering-stations-rework/soldering-materials/solder-paste.html',
            icon: 'paste'
        },
        {
            category: 'shielding-bags',
            tag: 'ESD',
            title: 'Static Shielding Bags',
            description: 'Protect sensitive components from electrostatic discharge',
            url: '/esd/esd-packaging/esd-bags.html',
            icon: 'bag'
        },
        {
            category: 'conformal-coatings',
            tag: 'Chemistry',
            title: 'Conformal Coatings',
            description: 'Protect PCBs from moisture, dust, and contaminants',
            url: '/soldering-stations-rework/soldering-chemistry/conformal-coatings.html',
            icon: 'coating'
        }
    ];

    var CATEGORIES = [
        {
            name: 'Cleaners & Aerosols',
            url: '/cleaners-aerosols.html',
            icon: 'spray',
            subcategories: [
                { name: 'Aerosols', url: '/cleaners-aerosols/aerosols.html' },
                { name: 'Dispensing', url: '/cleaners-aerosols/dispensing.html' },
                { name: 'Cleaners', url: '/cleaners-aerosols/cleaning-solvents.html' },
                { name: 'Cleaning Tools', url: '/cleaners-aerosols/cleaning-tools.html' }
            ]
        },
        {
            name: 'ESD',
            url: '/esd.html',
            icon: 'esd',
            subcategories: [
                { name: 'Packaging', url: '/esd/esd-packaging.html' },
                { name: 'Process', url: '/esd/esd-process.html' },
                { name: 'Ionization', url: '/esd/ionization.html' },
                { name: 'Grounding', url: '/esd/wrist-straps-grounding-hardware.html' },
                { name: 'Apparel', url: '/esd/esd-safe-garments-gloves.html' },
                { name: 'Mats', url: '/esd/esd-worksurface-mats.html' }
            ]
        },
        {
            name: 'Magnification & Lighting',
            url: '/magnification-lighting.html',
            icon: 'microscope',
            subcategories: [
                { name: 'Video Inspection', url: '/magnification-lighting/video-inspection-systems.html' },
                { name: 'Lighting', url: '/magnification-lighting/lighting.html' },
                { name: 'Magnifiers', url: '/magnification-lighting/magnifiers.html' },
                { name: 'Microscopes', url: '/magnification-lighting/microscopes.html' },
                { name: 'Machine Lights', url: '/magnification-lighting/machine-lights.html' }
            ]
        },
        {
            name: 'Packaging',
            url: '/packaging-tapes-labels.html',
            icon: 'package',
            subcategories: [
                { name: 'Labels', url: '/packaging-tapes-labels/labels.html' },
                { name: 'Tape', url: '/packaging-tapes-labels/tape.html' },
                { name: 'Moisture Control', url: '/packaging-tapes-labels/moisture-control.html' },
                { name: 'Shipping', url: '/packaging-tapes-labels/esd-safe-shipping.html' },
                { name: 'Label Printers', url: '/packaging-tapes-labels/label-printers.html' }
            ]
        },
        {
            name: 'Safety & Cleanroom',
            url: '/safety-first-aid.html',
            icon: 'safety',
            subcategories: [
                { name: 'Apparel', url: '/safety-first-aid/apparel.html' },
                { name: 'Gloves', url: '/safety-first-aid/gloves.html' },
                { name: 'Fume Extraction', url: '/safety-first-aid/fume-extraction.html' },
                { name: 'Skin Care', url: '/safety-first-aid/skin-care.html' }
            ]
        },
        {
            name: 'Soldering & Rework',
            url: '/soldering-stations-rework.html',
            icon: 'soldering',
            subcategories: [
                { name: 'Materials', url: '/soldering-stations-rework/soldering-materials.html' },
                { name: 'Chemistry', url: '/soldering-stations-rework/soldering-chemistry.html' },
                { name: 'Soldering', url: '/soldering-stations-rework/soldering.html' },
                { name: 'Tips & Nozzles', url: '/soldering-stations-rework/tips-nozzles.html' },
                { name: 'Rework', url: '/soldering-stations-rework/rework.html' }
            ]
        },
        {
            name: 'Seating & Storage',
            url: '/storage.html',
            icon: 'storage',
            subcategories: [
                { name: 'Trays', url: '/storage/trays.html' },
                { name: 'Handlers', url: '/storage/inplant-handlers.html' },
                { name: 'Bins', url: '/storage/bins.html' },
                { name: 'Seating', url: '/storage/technimark-seating.html' },
                { name: 'Reel Holders', url: '/storage/reel-holders.html' }
            ]
        },
        {
            name: 'Tools',
            url: '/tools.html',
            icon: 'tools',
            subcategories: [
                { name: 'Electric', url: '/tools/electric.html' },
                { name: 'Hand Tools', url: '/tools/hand-tools.html' },
                { name: 'Pneumatic', url: '/tools/pneumatic.html' },
                { name: 'Test Equipment', url: '/tools/test-equipment.html' },
                { name: 'Other Tools', url: '/tools/other-tools.html' }
            ]
        }
    ];

    var ABOUT_BADGES = [
        { icon: 'veteran', title: 'Veteran Owned', subtitle: 'Proudly veteran owned' },
        { icon: 'family', title: 'Family Operated', subtitle: 'Still going strong' },
        { icon: 'usa', title: 'Small Business', subtitle: 'American owned & operated' },
        { icon: 'ship', title: 'Fast Shipping', subtitle: 'Thousands of products in stock' }
    ];

    // Brand → Shopify collection handle. QRP and Weller have no dedicated
    // collection, so they fall back to the built-in vendor-filter URL.
    var BRANDS = [
        { name: 'ACL Staticide', url: '/collections/acl-staticide' },
        { name: 'Alpha', url: '/collections/alpha' },
        { name: 'ASG', url: '/collections/asg' },
        { name: 'AVEN', url: '/collections/aven' },
        { name: 'Beau Tech', url: '/collections/beautech' },
        { name: 'Bevco', url: '/collections/bevco' },
        { name: 'Bondhus', url: '/collections/bondhus' },
        { name: 'Brady', url: '/collections/brady' },
        { name: 'Chemtronics', url: '/collections/chemtronics' },
        { name: 'DCT', url: '/collections/dct' },
        { name: 'Desco', url: '/collections/desco' },
        { name: 'HAKKO', url: '/collections/hakko' },
        { name: 'Hexacon', url: '/collections/hexacon' },
        { name: 'Kester', url: '/collections/kester' },
        { name: 'Metcal', url: '/collections/metcal' },
        { name: 'QRP', url: '/collections/vendors?q=QRP' },
        { name: 'Techspray', url: '/collections/techspray' },
        { name: 'Weller', url: '/collections/vendors?q=Weller' },
        { name: 'Wiha', url: '/collections/wiha' },
        { name: 'Xuron', url: '/collections/xuron' }
    ];

    var ICONS = {
        spray: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10 2v8L8 14v6a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-6l-2-4V2"></path><path d="M8.5 2h7"></path><path d="M7 14h10"></path><circle cx="18" cy="4" r="1"></circle><circle cx="20" cy="7" r="1"></circle><circle cx="17" cy="9" r="1"></circle></svg>',
        esd: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"></path></svg>',
        microscope: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="5" r="3"></circle><path d="M12 8v8"></path><path d="M8 21h8"></path><path d="M12 16v5"></path><circle cx="12" cy="12" r="2"></circle><path d="M5 12h2"></path><path d="M17 12h2"></path></svg>',
        package: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></svg>',
        safety: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path><path d="M9 12l2 2 4-4"></path></svg>',
        soldering: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path></svg>',
        storage: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="3" y1="9" x2="21" y2="9"></line><line x1="3" y1="15" x2="21" y2="15"></line><line x1="9" y1="9" x2="9" y2="21"></line></svg>',
        tools: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path></svg>',
        arrow: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>',
        paste: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10 2v8L8 14v6a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-6l-2-4V2"></path><path d="M8.5 2h7"></path><path d="M7 14h10"></path></svg>',
        bag: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg>',
        coating: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>',
        veteran: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2L2 7l10 5 10-5-10-5z"></path><path d="M2 17l10 5 10-5"></path><path d="M2 12l10 5 10-5"></path></svg>',
        family: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>',
        usa: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>',
        ship: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>'
    };

    function createFeaturedCard(item) {
        var card = document.createElement('a');
        card.href = item.url;
        card.className = 'featured-card';
        card.dataset.category = item.category;
        card.innerHTML = '<div class="featured-bg"></div>' +
            '<div class="featured-icon">' + ICONS[item.icon] + '</div>' +
            '<div class="featured-content">' +
            '<span class="featured-tag">' + item.tag + '</span>' +
            '<h3>' + item.title + '</h3>' +
            '<p>' + item.description + '</p>' +
            '</div>';
        return card;
    }

    function createCategoryCard(category) {
        var card = document.createElement('div');
        card.className = 'category-card';

        var headerHtml = '<a href="' + category.url + '" class="category-card-header">' +
            '<div class="category-icon">' + ICONS[category.icon] + '</div>' +
            '<h3>' + category.name + '</h3>' +
            '</a>';

        var bodyHtml = '<div class="category-card-body"><ul class="subcategory-list">';
        category.subcategories.forEach(function(sub) {
            bodyHtml += '<li><a href="' + sub.url + '">' + sub.name + '</a></li>';
        });
        bodyHtml += '</ul>';
        bodyHtml += '<a href="' + category.url + '" class="view-all-link">View All ' + category.name + ' ' + ICONS.arrow + '</a>';
        bodyHtml += '</div>';

        card.innerHTML = headerHtml + bodyHtml;
        return card;
    }

    function createAboutBadge(badge) {
        var el = document.createElement('div');
        el.className = 'about-badge';
        el.innerHTML = '<div class="about-badge-icon">' + ICONS[badge.icon] + '</div>' +
            '<div class="about-badge-text">' +
            '<strong>' + badge.title + '</strong>' +
            '<span>' + badge.subtitle + '</span>' +
            '</div>';
        return el;
    }

    function createBrandCard(brand) {
        var card = document.createElement('a');
        card.href = brand.url;
        card.className = 'brand-card';
        card.textContent = brand.name;
        return card;
    }

    function createViewAllBrandsCard() {
        var card = document.createElement('a');
        card.href = '/pages/brands';
        card.className = 'brand-card view-all';
        card.textContent = 'View All Brands';
        return card;
    }

    function render(containerId, items, createFn) {
        var container = document.getElementById(containerId);
        if (!container) return;
        var fragment = document.createDocumentFragment();
        items.forEach(function(item) {
            fragment.appendChild(createFn(item));
        });
        container.appendChild(fragment);
    }

    function renderBrands() {
        var grid = document.getElementById('brandsGrid');
        if (!grid) return;
        var fragment = document.createDocumentFragment();
        BRANDS.forEach(function(brand) {
            fragment.appendChild(createBrandCard(brand));
        });
        fragment.appendChild(createViewAllBrandsCard());
        grid.appendChild(fragment);
    }

    function init() {
        render('categoriesGrid', CATEGORIES, createCategoryCard);
        render('featuredGrid', FEATURED, createFeaturedCard);
        render('aboutBadges', ABOUT_BADGES, createAboutBadge);
        renderBrands();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();